import { ReactComponent as FolderIcon } from 'img/icons/uploadFolder.svg';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Bubble } from 'reactApp/ui/Bubble/Bubble';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './PublicUploadHeader.css';

export class PublicUploadHeader extends PureComponent {
    static propTypes = {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        nick: PropTypes.string,
        avatar: PropTypes.string,
        onUploadClick: PropTypes.func,
        email: PropTypes.string,
        ownerEmail: PropTypes.string,
        showBubble: PropTypes.bool,
        onBubbleShow: PropTypes.func,
    };

    static defaultProps = {
        showBubble: false,
    };

    componentDidMount() {
        const { showBubble, onBubbleShow } = this.props;
        if (showBubble) {
            onBubbleShow();
        }
    }

    render() {
        const { firstName, lastName, onUploadClick, avatar, ownerEmail, showBubble, nick } = this.props;
        const name = `${firstName ? firstName : ''} ${lastName ? lastName : ''}`.trim() || nick || ownerEmail;

        return (
            <div className={styles.root}>
                <div className={styles.content}>
                    <div className={styles.avatar} style={{ backgroundImage: `url(${avatar})` }} />
                    {!!name && (
                        <div className={styles.meta}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.text}>сделал эту папку общей и разрешил загружать в нее файлы</div>
                        </div>
                    )}
                    <div className={styles.button}>
                        <Bubble
                            title="Загружайте файлы вместе"
                            text="В папку может грузить файлы любой, у кого есть&nbsp;ссылка"
                            isOpen={showBubble}
                            icon={<FolderIcon width={42} height={40} />}
                        >
                            <div>
                                <Button primary size="big" onClick={onUploadClick} theme="octavius">
                                    Загрузить файлы
                                </Button>
                            </div>
                        </Bubble>
                    </div>
                </div>
            </div>
        );
    }
}
